<template>
	<div class="wrapper" style="margin-top: 5rem">
		<!-- <banner height="55rem"></banner> -->

		<b-container>
			<!-- 未来科学大奖周 -->
			<div>
				<div class="title">
					<a>{{$t('lang.FSPW2020')}}</a>
					<div class="under-line"></div>
				</div>
                <div class="editContent">
                    <p><font size="1" color="#7f7f7f"></font></p><p><span style="font-size: small;"></span></p><p><font size="2"></font></p><p><font size="2">未来科学大奖是民间公益组织颁发的世界级科学大奖，由未来论坛于2016年创立。未来科学大奖采取提名邀约制和国际同行评议制，设置生命科学奖、物质科学奖和数学与计算机科学奖三个奖项，表彰大中华地区（包含中国大陆地区、香港、澳门及台湾）做出的、在世界上有长期重大影响力的科研成果。</font></p><p><font size="2">&nbsp;</font></p><p><font size="2">2021未来科学大奖周系列活动将于11月19日-21日在北京举办，为期三天。未来科学大奖颁奖典礼，旨在对为全人类做出重大科研成果的科学家予以表彰。颁奖典礼同期举行的</font><span style="font-size: small;">科学峰会，邀请全球范围内卓有建树的科学家，分享科学发展的前沿成果，探讨学科交叉与学术创新，是唯一在中国举办的多领域国际性科学盛会。</span></p><p><font size="2">&nbsp;</font></p><p><font size="2">未来科学大奖周邀请国内外知名专家组成指导委员会（Steering Committee）指导议题方向，下设程序委员会（Program Committee）制定议程、邀请国内外嘉宾，保证大会高水准的学术内容和广泛的国际影响。今年，由浙江大学励建书和斯坦福大学骆利群担任Program Committee的联席主席。</font></p><p><font size="2">&nbsp;</font></p><p><font size="2">科学改变未来，以科学精神影响大中华区、影响世界、影响下一代。</font></p><p><font size="2"></font></p>			<div class="clear"></div>
                </div>
				<!-- <div v-html="futureInfo"></div> -->
			</div>
            <!-- 议程 -->
			<div>
				<div
					class="title"
					style="display: flex; justify-content: space-between"
				>
					<div id="agenda">
						<a>{{$t('lang.agenda')}}</a>
						<div class="under-line"></div>
					</div>

					<ul class="date-wrap" style="flex:1">
						<li
							:class="current == index ? 'active' : ''"
							v-for="(item, index) in dateList"
							:key="index"
							@click="clickTab(index)"
						>
							{{ item }}
						</li>
					</ul>
				</div>
				<!-- agendaDataList
				<div v-for="">

				</div> -->
				<div v-for="(agendaItem, agendaIndex) in agendaDataList" :key="agendaIndex">
					<div v-show="current == agendaIndex" class="content" v-for="(item, index) in agendaItem" :key="index">
						<h1 style=" margin-top: 4rem; text-align:center">
							{{item.title}}
						</h1>
						<div
							style="margin: 0.8rem 0px; font-size: 1.2rem;color: #666666;text-align: center;"
						>
							{{formarDate(item.startTime)}}
							<a
								class="alink"
								:href="item.linkUrl"
							>
								{{item.url}}</a
							>
						</div>
						<agenda-table-old :table="JSON.parse(item.tables)"></agenda-table-old>
					</div>
				</div>
			</div>
			<!-- 学术指导 -->
			<div>
				<div id="academic_guidance" class="title">
					<a>{{$t('lang.academic')}}</a>
					<div class="under-line"></div>
				</div>
				<div v-for="(item, index) in donorProjectList" :key="index">
					<cu-table :tableData="item" ></cu-table>
				</div>
			</div>
			
			<!--参会报名-->
			<div>
				<div id="partners" class="title">
					<a>{{$t('lang.gegistration')}}</a>
					<div class="under-line"></div>
				</div>
				<iframe
					width="100%"
					src="https://www.bagevent.com/widget/ticket/5394424?widget=2"
					frameborder="0"
					scrolling="no"
					style="overflow: hidden; height: 20.46rem;"
				></iframe>
                <div class="notice-title">{{$t('lang.attention')}}</div>
                <div class="editContent" v-html="meetingData.mattersNeedAttention "></div>
				<div class="hotel-title">{{$t('lang.HandtInformation')}}</div>
				<div class="hotel-wrap pb-5" style="border-bottom: 0.1rem solid #ebebeb" v-for="(item, index) in meetingData.hotelList" :key="index">
					<div class="hotel-sub-title">
						<div>{{item.name}}</div>
						<div class="button-order"><a style="color: #fff; text-decoration: none;" :href="item.linkUrl">立即预定</a></div>
					</div>
					<div class="hotel-img">
						<div
							class="img-wrap img-hovor"
							style="height: 16rem; margin-right: 1rem; border-radius: 0; margin-right: 1rem"
							v-for="(item, index) in 3"
							:key="index"
						>
							<img
								width="100%"
								height="100%"
								:src="require('../../assets/index-hotel.jpg')"
							/>
						</div>
					</div>
					<div style="padding-left: 1rem; font-size: 1.2rem; line-height: 2rem" v-html="turn(item.nape)">
                     
					</div>
				</div>
			</div>
			<!-- 战略伙伴 -->
			<div v-if="partnerList">
				<div id="partners" class="title">
					<a>{{$t('lang.partner')}}</a>
					<a>{{$t('message.STRATEGICPARTNERS')}}</a>
					<div class="under-line"></div>
				</div>
				<div v-for="(item, index) in partnerList" :key="index">
					<h1 style=" margin-top: 4rem; text-align:center">
						{{ item.name }}
					</h1>
					<div class="icon-list mt-2 mb-2">
						<a
							class="icons-item"
							v-for="(iconItem, ind) in item.value"
							:key="ind"
							:href="iconItem.url"
							><img
								width="100%"
								height="100%"
								:src="iconItem.photoUrl"
						/></a>
					</div>
					<!-- <h1
                        style=" margin-top: 4rem; text-align:center"
                    >
                       直播支持
                    </h1>
                    <div class="icon-list mt-2 pb-5">
                        <a class="icons-item" v-for="(item, index) in 20" :key="index"><img width="100%" height="100%" src="http://www.futureprize.org/resource/data/uploads/11/b973ee7405bffb26cc588a9aa1aa7ee9.png" /></a>
                    </div> -->
				</div>
			</div>
			<!-- 联系我们 -->
			<div v-if="contactList">
				<div id="contact" class="title">
					<a>{{$t('lang.contact')}}</a>
					<div class="under-line"></div>
				</div>
				<div
					style="font-size: 1rem; line-height: 1rem; color: #666666;"
				>
					<div v-html="contactList.content">
					</div>
					<!-- <p>邮箱：{{ contactList.email }}</p>

					<p>联系人：{{ contactList.name }}</p>

					<p>电话：{{ contactList.phone }}</p> -->
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
import cuTable from '@/components/cuTable.vue'
import agendaTableOld from '@/components/agendaTableOld.vue'
export default {
	components: { cuTable, agendaTableOld },
	data() {
		return {
            futureInfo: '',
			current: 0,
			dateList: [
				// { date: '20.27' },
				// { date: '20.27' },
				// { date: '20.27' },
				// { date: '20.27' },
			],
			contactList: {},
            partnerList: [],
            meetingData: {
				mattersNeedAttention: '',
				hotelList:[]
			},
            donorProjectList: [],
            year: '',
            agendaDataList: [], //议程总数据
			
		}
	},
	
	created() {
        this.year = this.$route.query.year
        if(this.year){
            localStorage.setItem('BIGWEEKYEAR', this.year)
        }else{
            localStorage.getItem('BIGWEEKYEAR')
        }
        this.getAgendData(this.year)
		this.getFutureInfo(this.year)
		this.getPartners(this.year)
        this.getPrizeContact(this.year)
        this.meetingInvite(this.year)
        this.getDonorProject(this.year)
    },
    // mounted(){
    //     this.year = localStorage.getItem('BIGWEEKYEAR')
    //     this.getFutureInfo(this.year)
	// 	this.getPartners(this.year)
    //     this.getPrizeContact(this.year)
    //     this.meetingInvite(this.year)
    //     this.getDonorProject(this.year)
    // },
	methods: {
        //处理日期格式
        formarDate(date){
            let arr = date.split('-')
            let dateInstance = new Date(Number(arr[0]), Number(arr[1]), Number(arr[2]))
            console.log(this.weekday()[dateInstance.getDay()])
            // if(this.i18n.locale='cn'){
                 return  `${Number(arr[1])}月 ${Number(arr[2])}日 ${this.weekday()[dateInstance.getDay()]}`
            // }else{
            //     return dateInstance.split(' ').splice(0, 3).join(' ')
            // }
        },
        weekday(){
            let weekday = []
            weekday[0]="星期日"
            weekday[1]="星期一"
            weekday[2]="星期二"
            weekday[3]="星期三"
            weekday[4]="星期四"
            weekday[5]="星期五"
            weekday[6]="星期六"
            return weekday
        },
        //换行符号
        turn(data) {
            return data.replace(/(\r\n|\n|\r)/gm, "<br />");
        },
        //学术指导
        getDonorProject(year){
            this.$api.donorProject({
                projectId: year
            }).then(res=>{
                let arrKey = Object.keys(res.data)
                let arrValue = Object.values(res.data)
                this.donorProjectList = arrValue.map((item, index)=>{
                    return{
                        name: arrKey[index],
                        value: item
                    }
                })
                console.log('---------学术指导----------------------',this.donorProjectList)
                
            })
        },
        //大奖周概述
        getFutureInfo(year){
            this.$api.futureProject({
                projectId: year
            }).then(res=>{
               console.log(res.data)
               this.futureInfo = res.data.futureSummary
            })
        },
        //参会报名
        meetingInvite(year){
            this.$api.getPrizeMeetings({
                projectId: year
            })
            .then(res=>{
                console.log('参会报名',res.data)
				if(res.data){
                	this.meetingData = res.data

				}
                // console.log(this.meetingData.hotelList[0].nape)
            
            })
        },
        //合作伙伴
		getPrizeContact(year) {
			this.$api
				.getPrizeContact({
					projectId: year,
				})
				.then((res) => {
					// console.log('联系我们', res.data)
					this.contactList = res.data
				})
        },
        //议程tab按钮事件
        clickTab(index) {
            this.current = index;
            this.agendaData = this.agendaDataList[index];
			console.log('当前数据',this.agendaData)
		},
        //议程
		getAgendData(year) {
			this.$api
				.getAgendList({
					projectId: year,
				})
				.then((res) => {
                    // console.log('议程', res.data)
                    this.dateList = Object.keys(res.data).map(item=>{
                        let arr = item.split('-');
                        arr.splice(0, 1)
                        return arr.join('.')
                    })
                    this.agendaDataList = Object.values(res.data)

				})
        },
        //合作伙伴
		getPartners(year) {
			this.$api
            .getPartnerList({
                projectId: year,
            })
            .then((res) => {
                // console.log('战略伙伴', res.data)
                let keysArr = Object.keys(res.data)
                let valuesArr = Object.values(res.data)
                this.partnerList = keysArr.map((item, index) => {
                    return {
                        name: item,
                        value: valuesArr[index],
                    }
                })
            })
		},
		
	},
}
</script>
<style lang="scss" scoped>
.hotel-wrap {
	.hotel-img,
	.hotel-sub-title {
		display: flex;
		width: 100%;
		margin: 2rem 0px;
	}
	.hotel-sub-title {
		height: 2.57rem;
		line-height: 2.57rem;
		font-size: 1.28rem;
		padding-left: 0.7rem;
		justify-content: space-between;
		color: #666666;
		border-left: 6px solid #cfaf75;
		.button-order {
			border-radius: 0.5rem;
			background: #cfaf75;
			padding: 0 2rem;
            
		}
	}
	li {
		color: #666666;
		height: 1.57rem;
		line-height: 1.57rem;
		font-size: 1.2rem;
		margin: 1.4rem 0px;
		list-style-type: initial;
	}
}

.editContent {
    font-size: 1rem;
    color: #666666;
    line-height: 1.7rem;
    margin: 2.14rem 0px;
}

.notice-title{
    margin-top: 2rem;
    text-align: left;
    font-size: 1.2rem;
    color: #666666;
}

.title {
	height: 6rem;
	line-height: 6rem;
	margin: 2rem 0px;
	border-bottom: 0.1rem solid #ebebeb;
	overflow: hidden;
	#agenda {
		flex: 1;
	}
	.under-line {
		display: block;
		position: relative;
		top: -0.3rem;
		height: 0.3rem;
		width: 6rem;
		background: #cfaf75;
	}
	a {
		display: block;
		font-size: 1.2rem;
		color: #666666;
		font-weight: bold;
	}
	.date-wrap {
		display: flex;
		align-items: flex-end;
		margin-bottom: 0;
		li {
			flex: 1;
			margin-left: 0.4rem;
			height: 4rem;
			line-height: 4rem;
			font-size: 1.2rem;
			color: #ffffff;
			background: #eed7ab;
			border-top-right-radius: 14px;
			border-top-left-radius: 14px;
			text-align: center;
			cursor: pointer;
		}
		.active {
			height: 5rem;
			line-height: 5rem;
			background: #cfad6f;
		}
	}
}
.icon-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	.icons-item {
		display: block;
		width: 6rem;
		margin: 2rem;
	}
}
.hotel-title {
	background: #ebebeb;
	padding-left: 1.42rem;
	height: 5.7rem;
	color: #666666;
	font-size: 1.28rem;
	line-height: 5.7rem;
}

@media (max-width: 768px) {
	#agenda {
		flex: unset !important;
	}
}
</style>
